@if (visibleTabs$ | async; as plTabs) {
  <mat-toolbar class="tw-py-0 !tw-pr-0 tw-bg-transparent" style="background-color: transparent; color: white;">
    @for (tab of plTabs | slice:0:1; track tab.key) {
      <span class="tw-px-3 h-full tw-inline-block">
        <ng-template [ngTemplateOutlet]="TabButton" [ngTemplateOutletContext]="{tab:tab}"></ng-template>
      </span>
    }

    @for (tab of plTabs | slice:1:plTabs.length; track tab.key) {
      <span class="tw-px-3 h-full tw-hidden 2xl:tw-inline-block">
        <ng-template [ngTemplateOutlet]="TabButton" [ngTemplateOutletContext]="{tab:tab}"></ng-template>
      </span>
    }
    @if (plTabs.length > 2) {
      <span class="h-full tw-inline-block 2xl:tw-hidden tw-relative">
        <button
          data-cy="nav-more-tab"
          mat-button
          class="tw-px-3"
          [ngClass]="menuOpen ? 'tw-font-bold' : ''"
          [matMenuTriggerFor]="dropdownmenu"
          (menuOpened)="menuOpen=true;"
          (menuClosed)="menuOpen=false;"
        >
          More&nbsp;
          <i class="fa fa-angle-down"></i>
        </button>
        <mat-menu #dropdownmenu="matMenu" xPosition="after">
          @for (tab of plTabs | slice:1:plTabs.length; track tab.key) {
            <div
              class="tw-py-3 tw-px-5 tw-text-white dropdown-menu-item"
              (click)="onTabClick(tab)"
            >
              {{tab.text}}
            </div>
          }
        </mat-menu>
      </span>
    }
  </mat-toolbar>
}

<ng-template let-tab="tab" #TabButton>
  <button mat-button
          [ngClass]="activeTab?.key === tab?.key ? 'current-tab' : ''"
          [attr.data-cy]="tab ? 'nav-'+tab?.key+'-tab': ''"
          [routerLink]="tab.uri">
    {{tab.text}}
    @if (tab?.key === 'tasks' && (inboxBadgeCount$ | async)) {
      <div class="tw-ml-2 tw-text-sm tw-rounded-full counter-circle tw-items-center tw-justify-center tw-inline-flex tw-text-center tw-p-3 tw-tracking-normal">
        {{ displayBadgeCount(( inboxBadgeCount$ | async)) }}
      </div>
    }
    @if (tab?.key === 'today' && (todayBadgeCount$ | async)) {
      <div class="tw-ml-2 tw-text-sm counter-pill {{requestsCount < 10 ? 'single-digit' : ''}}">
        {{ displayBadgeCount(( todayBadgeCount$ | async)) }}
      </div>
    }
  </button>
</ng-template>
